import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from './Spinner';
import { usePipelineConnectionStatus } from '../context/PipelineEventsContext';

const ShowAfterMs = 5000;

/**
 * Tells the user that live updates are paused, from the moment the page's connection has been down for 5 s until it
 * is back. It floats at the bottom of the window, so the page's layout never moves.
 */
export default function ReconnectingIndicator() {
  const { t } = useTranslation();
  const status = usePipelineConnectionStatus();
  const down = status === 'connecting' || status === 'reconnecting';
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!down) return;
    const timer = window.setTimeout(() => setShown(true), ShowAfterMs);
    return () => {
      window.clearTimeout(timer);
      setShown(false);
    };
  }, [down]);

  if (!shown) return null;

  return (
    <div
      role="status"
      className="chip"
      style={{
        position: 'fixed',
        bottom: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        pointerEvents: 'none',
        background: 'var(--bg-2)',
        color: 'var(--text-5)',
        fontWeight: 500,
      }}
    >
      <Spinner size={10} />
      {t('connection.reconnecting')}
    </div>
  );
}
